module.exports = __webpack_public_path__ + "img/notviewicons.ac769d01.svg";